<app-school-district-view></app-school-district-view>  